import { useState, FC } from "react";
import { v4 as uuidv4 } from 'uuid';
import { useTranslation } from "react-i18next";
import DosageByStoreGrid from "./DosageByStoreGrid";
import DosageByStoreGridPluginSettings from "./DosageByStoreGridPluginSettings";
import { IEntitySimpleDTO } from "../../../../libs/coreapi-dto/@types/common";
import { GridSelectorModalWindow } from "../../../../components/modalWindows/GridSelectorModalWindow";

const DosageByStoreSelectorModal: FC<IGridSelectorModalProps> = (props) => {
    const [entity, setEntity] = useState<IEntitySimpleDTO>(props.selectedEntity ?? {} as IEntitySimpleDTO)
    const [entities, setEntities] = useState<IEntitySimpleDTO[]>(props.selectedEntity ?? []);
    const gridId = uuidv4();
    const plugin = DosageByStoreGridPluginSettings
    const { t } = useTranslation();
    return (
        <GridSelectorModalWindow
            entityToPressEnter={entity}
            gridDisplayName={plugin?.name ?? t('directory.Dosage.title')}
            ok={{
                onClick: () => props.multipleSelect ? props.ok(entities) : props.ok?.(entity),
            }}
            cancel={{ onClick: () => props.cancel?.() }}
        >
            {
                plugin
                    ? <DosageByStoreGrid
                        data={entities}
                        gridId={gridId}
                        plugin={plugin}
                        baseGridFilter={props.gridFilter}
                        multipleSelect={props.multipleSelect}
                        onSelect={(row) => row && setEntity({ idGlobal: row.idGoodsGlobal as string, displayName: row.dosage as string })}
                        onMultipleSelect={(rows) => {
                            rows && setEntities(rows.map(x => ({ idGlobal: x.idGoodsGlobal, displayName: x.dosage as string } as IEntitySimpleDTO)))
                        }}
                        onDoubleClick={(row) => {
                            setEntity({ idGlobal: row.idGoodsGlobal as string, displayName: row.dosage as string })
                            props.ok?.(entity)
                        }}
                    />
                    : <p>{t('general.directoryNotConfigured')} </p>
            }
        </GridSelectorModalWindow>
    )
}

export default DosageByStoreSelectorModal